//Return the response with messgae and data
exports.handleResponse = (res, responseObj, token) => {
  return res.status(responseObj.code).send({
    data: responseObj.data,
    message: responseObj.message,
    page: responseObj.page,
    perPage: responseObj.perPage,
    total: responseObj.total,
    extra_meta: {
      token: token,
    },
  });
};

exports.handleListingResponse = (res, responseObj) => {
  return res.status(responseObj.code).send({
    data: responseObj.data,
    meta: {
      current_page: responseObj.current_page,
      from: 21,
      last_page: responseObj.last_page,
      path: responseObj.path,
      per_page: responseObj.per_page,
      to: 23,
      total: responseObj.total,
    },
    extra: responseObj.extra || {},
  });
};

exports.handleListingResponseMinField = (res, responseObj) => {
  const extraMeta = responseObj?.extraMeta || {};
  return res.status(responseObj.code).send({
    data: responseObj.data,
    meta: {
      current_page: responseObj.current_page,
      last_page: responseObj.last_page,
      per_page: responseObj.per_page,
      total: responseObj.total,
      ...extraMeta,
    },
  });
};

exports.handleListingStatusResponseMinField = (res, responseObj) => {
  return res.status(responseObj.code).send({
    data: responseObj.data,
    statusObject: responseObj.statusObject,
    notification: responseObj.notification,
    meta: {
      current_page: responseObj.current_page,
      last_page: responseObj.last_page,
      per_page: responseObj.per_page,
      total: responseObj.total,
    },
  });
};

exports.handleUserListingResponseMinField = (res, responseObj) => {
  return res.status(responseObj.code).send({
    data: responseObj.data,
    meta: {
      current_page: responseObj.current_page,
      last_page: responseObj.last_page,
      per_page: responseObj.per_page,
      active: responseObj.active,
      inactive: responseObj.inactive,
      adminCount: responseObj.adminCount,
      total: responseObj.total,
    },
  });
};

exports.handleMessageResponse = (res, responseObj) => {
  return res.status(responseObj.code).send({
    data: {},
    extra_meta: {
      message: responseObj.message,
    },
  });
};

exports.handleListMessageResponse = (res, responseObj) => {
  return res.status(responseObj.code).send({
    data: responseObj.data,
    extra_meta: {
      message: responseObj.message,
    },
  });
};
